import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { Article } from "../../data/articles";

export function ArticleCta({ article, testId }: { article: Article; testId: string }) {
  return (
    <aside data-testid={testId} className="my-10 rounded-xl border border-slate-800 bg-slate-900/60 p-6">
      <p className="text-base font-semibold leading-snug text-slate-100">
        Deseja formalizar sua Notificação Extrajudicial contra {article.targetEntity} agora?
      </p>
      <div className="mt-5 flex flex-wrap items-center gap-4">
        <span data-testid={`${testId}-price`} className="rounded-md border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 font-mono text-sm font-medium text-emerald-400">
          {article.ctaPrice}
        </span>
        <Link to={article.nicheUrl} data-testid={`${testId}-link`} className="btn-primary">
          Gerar minha notificação<ArrowRight aria-hidden="true" className="h-4 w-4" />
        </Link>
      </div>
    </aside>
  );
}
